"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return OutlineNewsletters;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function OutlineNewsletters(props) {
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ _react.createElement("g", {
        clipPath: "url(#clip0_3083_39996)"
    }, /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 13H20V15H8V13Z",
        fill: "white"
    }), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 17H20V19H8V17Z",
        fill: "white"
    }), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 5H20V11H8V5ZM10 7V9H18V7H10Z",
        fill: "white"
    }), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.00006 0L4.00006 1V12H1C0.447715 12 0 12.4477 0 13V21L4.47035e-06 21.003C0.0023762 21.7971 0.318893 22.558 0.880428 23.1196C1.44196 23.6811 2.20289 23.9976 2.99701 24L3.00006 24L3.99701 24.003L3.99702 24H21.0001L21.003 24C21.7972 23.9976 22.5581 23.6811 23.1196 23.1196C23.6812 22.558 23.9977 21.7971 24.0001 21.003L24.0001 21V1L23.0001 0H5.00006ZM3.00003 22C3.26473 21.9984 3.51819 21.8926 3.70542 21.7054C3.89305 21.5177 3.99894 21.2636 4.00006 20.9982V14H2V20.9983C2.00112 21.2636 2.10701 21.5177 2.29464 21.7054C2.48187 21.8926 2.73533 21.9984 3.00003 22ZM6.00006 21V2H22.0001V20.9981C21.999 21.2635 21.8931 21.5177 21.7054 21.7054C21.5177 21.893 21.2635 21.9989 20.9982 22H5.82674C5.9394 21.6828 5.99903 21.346 6.00005 21.003L6.00006 21Z",
        fill: "white"
    })), /*#__PURE__*/ _react.createElement("defs", null, /*#__PURE__*/ _react.createElement("clipPath", {
        id: "clip0_3083_39996"
    }, /*#__PURE__*/ _react.createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));
}

//# sourceMappingURL=OutlineNewsletters.js.map